import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadUsers } from './actions';
import { loadUnpagedRoles } from '../roles/actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';

class Users extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadRoles();

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadRoles() {
		const { loadUnpagedRoles } = this.props;
		loadUnpagedRoles();
	}

	render() {
		const { isReadonly, roles } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} roles={roles} loading={this.props.pagination.loading} />
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { users, roles },
		auth: { currentUser }
	} = state;

	const usersPagination = pagination.users.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: usersPagination.ids.map(id => users[id]),
		pagination: usersPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Users'),
		roles: roles
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadUsers,
	loadUnpagedRoles: loadUnpagedRoles,
	initializeFilter: (data, fields) => initialize('usersFilter', data, fields)
})(Users);